import { observable } from "mobx";
import { Type } from "class-transformer";
import LinkListItem from "./linkListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class LinkList {
  @observable
  total!: number;

  @observable
  @Type(() => LinkListItem)
  links!: LinkListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    links: { required: true },
  };
}
